var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"oral-flash-messages\">\n<div ng-repeat=\"message in $ctrl.messageList\" ng-animate=\"'animate'\" class=\"oral-flash-msg animate-slow mdc-elevation--z10\" ng-class=\"message.classes\" role=\"alert\">\n<div class=\"flash-warning-area icon icon-warning icon-32 white\"></div>\n<div class=\"flash-message-text\">{{ message.content }}</div>\n<div class=\"flash-close-area\">\n<button class=\"flash-close-button mdc-button mdc-button--white mdc-button--minimal\" ng-click=\"$ctrl.closeFlashMessage(message.id)\">\n<i class=\"icon icon-x icon-18 white\"></i>\n<span translate>Sulje</span>\n</button>\n</div>\n</div>\n</div>\n";
var id1="common/flashmessageservice/flashmessage.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/common/flashmessageservice/flashmessage.tpl.html
// module id = 439
// module chunks = 4